import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Avatar from '@/components/avatar/Index.vue';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
let OverviewList = class OverviewList extends Vue {
};
__decorate([
    Prop({ type: Array, default: () => [] })
], OverviewList.prototype, "listHeaders", void 0);
__decorate([
    Prop({ type: String, default: '' })
], OverviewList.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: '0' })
], OverviewList.prototype, "count", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], OverviewList.prototype, "countEnabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], OverviewList.prototype, "paginated", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], OverviewList.prototype, "loading", void 0);
__decorate([
    Prop({ type: String, default: '/' })
], OverviewList.prototype, "listPath", void 0);
OverviewList = __decorate([
    Component({
        components: {
            Avatar,
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
        },
    })
], OverviewList);
export default OverviewList;
